<template>
    <div class="flex flex-col">
        <span class="mx-auto mt-32 pb-32" v-if="!subscription">
            <svg version="1.1" class="h-8 w-8 fill-current" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(19.7256 25 25)">
                    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                </path>
            </svg>
        </span>

        <div class="relative z-0 w-full px-5 sm:px-10" v-else>
            <div class="absolute inset-x-0 top-0 z-0 bg-wecare-red" style="height: 400px;"></div>
            
            <form class="relative z-10 flex flex-col w-full mx-auto" style="max-width: 1200px" @submit.prevent="submit" v-if="step === 'form'">
                <span class="text-center mx-auto text-white mt-4">Vous êtes limité à une déclaration de sinistre par année</span>

                <div class="flex flex-col bg-white border border-gray-600 my-4 p-3 sm:p-10 rounded-lg login-form" style="border-color: rgb(216, 221, 228);">
                    <img src="@/assets/img/smartphone-repair.svg" class="h-24 w-auto mx-auto mb-2" />
                    <span class="text-4xl font-bold mx-auto text-auto leading-none text-center">Déclarer <span class="text-wecare-red">un sinistre</span></span>
                    <div class="border-t border-gray-500 mb-8 mt-6 w-full mx-auto" style="max-width: 900px"></div>

                    <span class="font-medium text-gray-700 text-lg mx-auto text-center mb-5 -mt-3">Produit couvert par l’assurance WeCare</span>

                    <div class="w-full flex-col md:flex-row flex items-center w-full mx-auto" style="max-width: 700px">
                        <img :src="phoneImageUrl" class="w-auto h-64" />

                        <div class="flex flex-col text-left w-full">
                            <div class="flex flex-col w-full border-b border-gray-500 py-3">
                                <span class="text-lg font-medium text-gray-700">Marque du smartphone</span>
                                <span class="text-2xl font-bold">{{ subscription.product_mark }}</span>
                            </div>

                            <div class="flex flex-col w-full border-b border-gray-500 py-3">
                                <span class="text-lg font-medium text-gray-700">Modèle du smartphone</span>
                                <span class="text-2xl font-bold">{{ subscription.product_model }}</span>
                            </div>

                            <div class="flex flex-col w-full py-3">
                                <span class="text-lg font-medium text-gray-700">Numéro d'IMEI de votre smartphone</span>
                                <span class="text-2xl font-bold">{{ subscription.product_imei }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-col bg-white border border-gray-600 my-4 p-10 rounded-lg login-form" style="border-color: rgb(216, 221, 228);">
                    <span class="text-4xl font-bold mx-auto text-auto">Preuve <span class="text-wecare-red">d'achat</span></span>
                    <div class="border-t border-gray-500 mb-8 mt-6 w-full mx-auto" style="max-width: 900px"></div>
                    <div class="flex flex-col mx-auto w-full" style="max-width: 777px">
                        <span class="mx-auto text-lg text-center text-gray-700 font-medium">Attachez via glisser-déposer une preuve d'achat de la protection WeCare :</span>
                        <dropzone class="mt-3" v-model="form.invoice"/>
                        <span class="mx-auto text-sm text-gray-500 mt-2">Cela peut-être une facture ou un ticket de caisse</span>
                    </div>

                    <span class="mt-1 md:mt-2 mb-3 text-sm md:text-base md:font-bold mx-auto text-center" style="color: rgb(248, 64, 54);" v-if="errors && errors.invoice">
                        <span class="block" v-for="(error, index) in errors.invoice" :key="index">{{ error }}</span>
                    </span>
                </div>
                
                <div class="flex flex-col bg-white border border-gray-600 my-4 p-10 rounded-lg login-form" style="border-color: rgb(216, 221, 228);">
                    <span class="text-4xl font-bold mx-auto text-auto text-center leading-none">Quand s'est produit <span class="text-wecare-red">la casse ?</span></span>
                    <div class="border-t border-gray-500 mb-8 mt-6 w-full mx-auto" style="max-width: 900px"></div>
                    <div class="flex flex-col mx-auto w-full" style="max-width: 555px">
                        <span class="mx-auto text-lg text-center text-gray-700 font-medium">Indiquez la date de survenance du sinistre :</span>
                        <DateSelector class="mt-3" v-model="form.occurred_at" :errors="errors && errors.occurred_at ? errors.occurred_at : []" />
                    </div>
                </div>

                <div class="flex flex-col bg-white border border-gray-600 my-4 p-10 rounded-lg login-form" style="border-color: rgb(216, 221, 228);">
                    <span class="text-4xl font-bold mx-auto text-auto text-center leading-none">Que s'est-il <span class="text-wecare-red">passé ?</span></span>
                    <div class="border-t border-gray-500 mb-8 mt-6 w-full mx-auto" style="max-width: 900px"></div>
                    <div class="flex flex-col mx-auto w-full" style="max-width: 777px">
                        <span class="mx-auto text-lg text-center text-gray-700 font-medium">Indiquez les circonstances de la casse de votre smartphone :</span>
                        <textarea v-model="form.circumstances" id="" cols="30" rows="10" placeholder="Que s’est-il passé, dites-nous tout !" class="w-full bg-gray-100 outline-none mt-3 mb-10 border-2 border-gray-700 rounded p-3" style="background: #f2f2f2"></textarea>
                    </div>

                    <span class="mt-1 md:mt-2 mb-3 text-sm md:text-base md:font-bold mx-auto text-center" style="color: rgb(248, 64, 54);" v-if="errors && errors.circumstances">
                        <span class="block" v-for="(error, index) in errors.circumstances" :key="index">{{ error }}</span>
                    </span>
                </div>

                <div class="flex flex-col bg-white border border-gray-600 my-4 p-10 rounded-lg login-form" style="border-color: rgb(216, 221, 228);">
                    <span class="text-4xl font-bold mx-auto text-auto text-center leading-none">Montrez-nous <span class="text-wecare-red">la casse</span></span>
                    <div class="border-t border-gray-500 mb-8 mt-6 w-full mx-auto" style="max-width: 900px"></div>
                    <div class="flex flex-col mx-auto w-full" style="max-width: 777px">
                        <span class="mx-auto text-lg text-center text-gray-700 font-medium">Attachez via glisser-déposer une photo de votre appareil endommagé :</span>
                        <dropzone class="mt-3" v-model="form.product_broken" />
                    </div>

                    <span class="mt-1 md:mt-2 mb-3 text-sm md:text-base md:font-bold mx-auto text-center" style="color: rgb(248, 64, 54);" v-if="errors && errors.product_broken">
                        <span class="block" v-for="(error, index) in errors.product_broken" :key="index">{{ error }}</span>
                    </span>
                </div>

                <div class="flex flex-col bg-white border border-gray-600 my-4 p-10 mb-20 rounded-lg login-form" style="border-color: rgb(216, 221, 228);">
                    <span class="text-4xl font-bold mx-auto text-auto text-center leading-none">Je fais réparer <span class="text-wecare-red">mon smartphone</span></span>
                    <div class="border-t border-gray-500 mb-8 mt-6 w-full mx-auto" style="max-width: 900px"></div>
                    <div class="flex flex-col mx-auto w-full" style="max-width: 777px">
                        <span class="relative flex items-center mb-4 mr-auto -mt-2 cursor-pointer mx-auto">
                            <input type="checkbox" id="check_exact" v-model="check_exact" class="-mt-1"/>
                            <label for="check_exact" class="text-sm md:text-base ml-2 text-gray-600 cursor-pointer">J’atteste sur l’honneur que toutes ces informations sont exactes.</label>    
                        </span>

                        <span class="mx-auto text-center font-bold text-black text-sm mb-1">Vous êtes limité à une délaration de sinistre par année</span>

                        <input type="submit" class="btn h-20 cursor-pointer border border-wecare-red bg-wecare-red hover:scale-105 hover:bg-white hover:text-wecare-red" value="Valider ma déclaration" v-if="!isLoading" />

                        <span class="btn h-20 bg-wecare-red cursor-wait" v-else>
                            <svg version="1.1" class="text-white fill-current" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                                <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" transform="rotate(19.7256 25 25)">
                                    <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
                                </path>
                            </svg>
                        </span>
                    </div>
                </div>
            </form>

            <div class="flex flex-col items-center" v-if="step === 'thanks'">
                <div class="flex flex-col bg-white border border-gray-600 my-4 p-3 sm:p-10 rounded-lg login-form"  style="max-width: 1200px; border-color: rgb(216, 221, 228);">
                    <img src="@/assets/img/smartphone-repair-ok.svg" class="h-24 w-auto mx-auto mb-2" />
                    <span class="text-4xl font-bold mx-auto text-auto leading-none text-center">Bien <span class="text-wecare-green">reçu !</span></span>

                    <span class="font-bold text-black text-3xl mx-auto text-center my-10 leading-tight">Nous avons bien reçu votre déclaration de sinistre. Vous allez recevoir un mail dans les prochaines minutes détaillant les prochaines étapes.</span>
                    <router-link to="client" class="btn h-20 cursor-pointer border border-wecare-green bg-wecare-green hover:scale-105 hover:bg-white hover:text-wecare-green">J'accède à mon compte</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getSubscription, claim } from '@/auth'

import Dropzone from '@/components/forms/Dropzone'
import DateSelector from '@/components/forms/Date'

const slugify = require('slugify')

export default {
    components: { Dropzone, DateSelector },
    data: function () {
        return {
            type: 'breakage',
            step: 'form',
            occured_at: null,
            subscription: null,
            check_exact: false,
            isLoading: false,
            errors: null,
            customErrorMessage: null,
            form: {
                invoice: null,
                occurred_at: null,
                circumstances: null,
                product_broken: null
            }
        }
    },
    computed: {
        phoneImageUrl() {
            return '/phones/wecare-' + slugify(this.subscription.product_mark + '-' + this.subscription.product_model, {lower: true}) + '.jpg'
        }
    },
    mounted: function () {
        getSubscription()
        .then(({data}) => {
            this.subscription = data
        }).catch(() => {
            window.sessionStorage.removeItem('access_token')
            this.$router.push('/login?session=expired')
        })
    },
    methods: {
        submit: function () {
            this.isLoading = true
            this.errors = null
            this.customErrorMessage = null

            claim(this.form)
            .then(({data}) => {
                this.step = 'thanks'
            },
            (response) => {
                console.log(response.message)
                this.errors = response.response.data.errors
                this.customErrorMessage = response.message

                this.isLoading = false
            })
        }
    }
}
</script>